import { Fragment, useMemo } from "react";
import { Link, useLocation } from "react-router";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";

const getBreadcrumbs = (pathname: string) => {
  const segments = pathname.split("/").filter(Boolean);

  if (segments[0] === "gas-calculator") {
    return [{ path: "/gas-calculator", title: "Gas", isLast: true }];
  } else if (segments[0] === "skus" && segments[1] === "create") {
    return [
      { path: "/skus", title: "SKUs", isLast: false },
      { path: "/skus/create", title: "Create SKU", isLast: true },
    ];
  }

  return segments.map((segment, index) => {
    const path = `/${segments.slice(0, index + 1).join("/")}`;
    const title = segment.replace(/-/g, " ").replace("sku", "SKU");

    return { path, title, isLast: index === segments.length - 1 };
  });
};

export const AppBreadcrumb = () => {
  const location = useLocation();

  const breadcrumbs = useMemo(() => {
    return getBreadcrumbs(location.pathname);
  }, [location.pathname]);

  return (
    <header className="flex items-center gap-2 p-4 border-b fixed top-0 w-full bg-white z-5">
      <SidebarTrigger />
      <Separator orientation="vertical" className="mr-2 max-h-4" />
      <Breadcrumb>
        <BreadcrumbList>
          {breadcrumbs.map(({ path, title, isLast }) =>
            isLast ? (
              <BreadcrumbItem key={path} className="capitalize">
                <BreadcrumbPage>{title}</BreadcrumbPage>
              </BreadcrumbItem>
            ) : (
              <Fragment key={path}>
                <BreadcrumbItem className="capitalize">
                  <BreadcrumbLink asChild>
                    <Link to={path}>{title}</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
              </Fragment>
            ),
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </header>
  );
};
